import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DcpReviewSubmitComponent} from './dcp-review-submit.component';
import {I18nModule} from '@spartacus/core';
import {DisposableMessageModule} from '@app/shared/disposable-message/disposable-message.module';
import {BundleProvidedByModule} from '../bundle-provided-by/bundle-provided-by.module';
import {TermsAndConditionsModule} from '../checkout-terms-conditions/terms-and-conditions.module';
import {OrderTableModule} from '../order-table/order-table.module';
import {ProvidedByModule} from '../provided-by/provided-by.module';
import {SummaryModule} from '@app/shared/summary/summary.module';
import {
  InvalidCartEntryMessageModule
} from '../error-handling/invalid-cart-entry-message/invalid-cart-entry-message.module';
import {
  ConfigureServiceErrorModule
} from '@app/product/configurator/error-handling/configure-service-error/configure-service-error.module';
import {NgDesignSystemModule} from 'ng-design-system';
import {
  AdditionalRequiredSolutionsButtonModule
} from '../additional-required-solutions-button/additional-required-solutions-button.module';
import {GroupTotalModule} from '../group-total/group-total.module';
import {CartHeaderInformationComponent} from './cart-header-information/cart-header-information.component';
import {
  CartHeaderInformationItemComponent
} from './cart-header-information-item/cart-header-information-item.component';
import {PaymentModule} from '@app/payment/payment.module';
import {NavigationToModule} from '@app/shared/navigation-to/navigation-to.module';
import {
  ContentLoadingIndicatorModule
} from '@app/shared/content-loading-indicator/content-loading-indicator.module';
import {
  OrderHistoryProcessingErrorModule
} from '../error-handling/order-history-processing-error/order-history-processing-error.module';
import {RecurringTotalModule} from '../recurring-total/recurring-total.module';
import {CheckoutPaymentsModule} from '@app/checkout/checkout-payments/checkout-payments.module';
import {LoadingPageModule} from '@dcp/configurator';

@NgModule({
  declarations: [
    DcpReviewSubmitComponent,
    CartHeaderInformationComponent,
    CartHeaderInformationItemComponent
  ],
  imports: [
    AdditionalRequiredSolutionsButtonModule,
    CommonModule,
    I18nModule,
    DisposableMessageModule,
    BundleProvidedByModule,
    TermsAndConditionsModule,
    OrderTableModule,
    ProvidedByModule,
    SummaryModule,
    InvalidCartEntryMessageModule,
    ConfigureServiceErrorModule,
    NgDesignSystemModule,
    GroupTotalModule,
    PaymentModule,
    NavigationToModule,
    ContentLoadingIndicatorModule,
    OrderHistoryProcessingErrorModule,
    RecurringTotalModule,
    CheckoutPaymentsModule,
    LoadingPageModule,
  ],
  exports: [
    DcpReviewSubmitComponent,
    CartHeaderInformationComponent,
    CartHeaderInformationItemComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ]
})
export class DcpReviewSubmitModule {
}
